/** @jsx jsx */
import React from 'react';
import { jsx } from '@emotion/core';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@material-ui/lab';
import { useMediaQuery, useTheme } from '@material-ui/core';

import { ICustomTheme, LoadingStatusType } from 'interfaces';
import { LOADING_STATUS } from 'constants/status';
import * as S from './styles';

const { cssNegativeTop, cssDescription } = S;

type DescriptionProps = {
  texts: [string, string, string?];
  resultsLoadingStatus?: LoadingStatusType;
  showRecommendations?: boolean;
  showVoteDescription?: boolean;
  votes?: number;
};

const Description = ({
  texts,
  resultsLoadingStatus,
  showRecommendations = false,
  showVoteDescription = false,
  votes = 0,
}: DescriptionProps): JSX.Element => {
  const { t } = useTranslation();
  const theme: ICustomTheme = useTheme();
  const isDownSm = useMediaQuery(theme.breakpoints.down('sm'));

  if (resultsLoadingStatus === LOADING_STATUS.PENDING) {
    return <Skeleton variant="rect" height={150} />;
  }
  const [subtitle, description1, description2] = texts;

  return (
    <React.Fragment>
      <S.Subtitle variant={isDownSm ? 'h5' : 'h3'}>{subtitle}</S.Subtitle>
      {description1 && (
        <S.Description variant="h4" css={cssDescription}>
          {description1}
        </S.Description>
      )}
      {description2 && (
        <S.Description
          variant="h4"
          isBold
          css={(theme) => [cssDescription(theme), cssNegativeTop(theme)]}
        >
          {description2}
        </S.Description>
      )}
      {showRecommendations && (
        <S.SizeRecommendations variant="body2">
          {t(
            'photo_contest.results.undefined_status.recommended_image_formats_sizes',
          )}
        </S.SizeRecommendations>
      )}

      {showVoteDescription && (
        <S.Description variant={isDownSm ? 'body1' : 'h4'} isBold>
          {t('challenges.vote', { count: votes })}
        </S.Description>
      )}
    </React.Fragment>
  );
};

export default Description;
